export default __webpack_public_path__ + "static/media/guide2.194f34a0.png";